export default __webpack_public_path__ + "static/media/icon-settings-light.3aa9f240.svg";